import { Divider, Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import IssbContainer from "../IssbContainer";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import AuditDashboard from "../Dashboard/AuditDashboard";
import { H1 } from "components/text/headings";
import AuditRequirementList from "./AuditRequirementList";
import withAuthorization from "../../../context/Auth/WithAuthorization";
import { useTranslation } from "react-i18next";

const AuditControlPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const roundSelector = useSelector((state) => state.issbRound);

  // Support tab navigation and linking: set the tab index from the query param
  const tabIndex = parseInt(searchParams.get("rtab")) || 0; // Default to the first tab
  const [selectedTab, setSelectedTab] = React.useState(tabIndex);
  const setTabIndex = (index) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("rtab", index);
    setSearchParams(newParams);
    setSelectedTab(index);
  };

  const { t } = useTranslation("translation", {
    keyPrefix: "issb.auditControlPage.titles",
  });

  useEffect(() => {
    const newTabIndex = parseInt(searchParams.get("rtab")) || 0;
    setSelectedTab(newTabIndex);
  }, [searchParams]);

  return (
    <IssbContainer>
      <Flex direction="column" gap={2}>
        <H1>Internal Audit</H1>
        <Text maxW="75%" color="gray.500" fontSize="body.m">
          {t(selectedTab)}
        </Text>
      </Flex>
      <Tabs variant="primary" isLazy={true} defaultIndex={tabIndex} index={tabIndex} onChange={setTabIndex}>
        <TabList>
          <Tab>Status</Tab>
          <Tab>Requirements</Tab>
        </TabList>

        <Divider />

        {roundSelector?.selectedRound ? (
          <TabPanels>
            <TabPanel px={0}>
              <AuditDashboard />
            </TabPanel>
            <TabPanel px={0}>
              <AuditRequirementList />
            </TabPanel>
            {/*<TabPanel px={0}>*/}
            {/*  <SourcesListPanel />*/}
            {/*</TabPanel>*/}
          </TabPanels>
        ) : (
          <Text color="darkTeal" fontSize="body.m" my={4}>
            Please select a round to get started
          </Text>
        )}
      </Tabs>
    </IssbContainer>
  );
};

export default withAuthorization(AuditControlPage);
